//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    tab: {
      default: ''
    }
  },
  data: () => ({
    table: [],
    loading: false
  }),
  components: {
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'brand') {
            this.handleLoadTableData()
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, )
      // console.log('data', data)
      this.$axios.get('mtea/store/admin/goods/brand/list', { params: data }).then(res => {
        // console.log('res', res)


        this.table = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
